<template>
  <div  class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">CRM管理</Breadcrumb-item>
        <Breadcrumb-item>分配记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div v-if="fromSalesDealRate" style="margin-top: 10px">
      <Button @click="goBackSalesDealRate" icon="ios-arrow-back">返回销售成交率</Button>
      <span style="margin-left: 12px">成交率分配明细，本周按公式筛选</span>
    </div>
    <div v-else-if="fromChannelDealRate" style="margin-top: 10px">
      <Button @click="goBackChannelDealRate" icon="ios-arrow-back">返回渠道成交率</Button>
      <span style="margin-left: 12px">渠道成交率分配明细，本周按公式筛选</span>
    </div>
    <div v-else style="margin-top: 10px">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Row>
            <Col span="6">
            <Form-item label="学生:" :label-width="70">
              <Input placeholder="ID/手机号/姓名" name="searchKeyword"
                     v-model="queryParam.searchKeyword"></Input>
            </Form-item>
            </Col>
            <Col span="6">
            <FormItem label="学员状态：">
              <Select v-model="queryParam.stdStatus"  placeholder="不论">
                <Option value="1">新注册</Option>
                <Option value="3">已预约</Option>
                <Option value="4">已试听</Option>
                <Option value="5">付款未绑定</Option>
                <Option value="6">已绑定</Option>
                <Option value="7">已开课</Option>
                <Option value="8">已完课</Option>
                <Option value="9">退费</Option>
                <Option value="-1">不论</Option>
              </Select>
            </FormItem>
            </Col>
          </Row>
        </Row>
        <Row :gutter="32">
          <Col span="6">
            <FormItem label="分配来源：">
              <Select v-model="queryParam.recordsSource" placeholder="不论">
                <Option v-for="item in $constant.recordsSource"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </FormItem>
            </Col>
            <Col span="8">
            <Form-item  label="分配时间:">
              <Col span="11">
              <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                           @on-change="linkTimeStartChange"
                           :value="queryParam.linkStartTimeDate" style="width: 100%;"></Date-picker>
              </Col>
              <Col span="1" style="text-align: center">
              -</Col>
              <Col span="11">
              <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                           @on-change="linkTimeEndChange"
                           :value="queryParam.linkEndTimeDate" style="width: 100%;"></Date-picker>
              </Col>
            </Form-item>
            </Col>
            <Col span="6">
              <Form-item :label-width="60" label="渠道分类">
                <Select v-model="queryParam.channelType" clearable>
                  <Option v-for="item in this.$constant.channelTypeEnum" :value="item.id" :key="item.id">{{ item.text }}</Option>
                </Select>
              </Form-item>
            </Col>
            <Button type="primary" @click="search()">搜索</Button>
        </Row>
      </Form>
      <Col>
      </Col>
    </div>
    <adviser-float-modal v-if="!fromSalesDealRate && !fromChannelDealRate" :adviserId="queryParam.adviserId" :teamType="queryParam.teamType" @get_adviser="getAdviserInfo"></adviser-float-modal>
    <List style="margin-top: 10px" :tableColumns="assignTitle" listUrl="/userinfo/distribution"
          :params="queryParam" :onLoading="onLoading" :reload="reload" @on-selection-change="selectionChange"></List>
  </div>
</template>
<script>
  import AdviserFloatModal from '../common/AdviserFloatModal.vue'
  export default {
    components: {
      AdviserFloatModal
    },
    data () {
      let $constant = this.$constant
      // 初始化日期为当地 0 点，格式为 yyyy-MM-dd
      const now = new Date()
      const momentDate = this.$moment([now.getFullYear(), now.getMonth(), now.getDate()])
      const formattedDate = momentDate.format('YYYY-MM-DD')

      return {
        exportLoading: false,
        showAssignAdviserModal: false,
        selectionUser: [],
        searchLoading: false,
        editUser: false,
        reload: 0,
        uid: null,
        fromSalesDealRate: false,
        fromChannelDealRate: false,
        queryParam: {
          recordsSource: '',
          stdStatus: '',
          connectionStatus: '',
          regStartTimeDate: '',
          regEndTimeDate: '',
          linkStartTimeDate: formattedDate,
          startTime: momentDate.format('X'),
          linkEndTimeDate: '',
          studentTag: null,
          bookTestId: '',
          searchKeyword: '',
          studyAdviserId: '',
          studentLessonState: '',
          adviserId: null,
          adviserIds: [],
          teamType: null,
          salesDealRate: '',
          weekStart: '',
        },
        studyAdvisers: [],
        assignTitle: [
          {
            title: '学生ID/姓名',
            // width: 150,
            render: (h, params) => {
              let row = params.row
              let remark = row.remark
              if (remark && remark.indexOf('开始') !== -1) {
                return h('div', [
                  h('span', row.uid + '-' + row.nickName),
                  h('br'),
                  h('span', { style: { fontSize: '12px', color: '#19be6b' } }, remark)
                ])
              }
              return h('span', row.uid + '-' + row.nickName)
            }
          },
          {
            title: '手机号',
            key: 'mobile',
            // width: 120,
            render: (h, params) => {
              if (params.row.mobile.startsWith('n')) {
                return h('span', '')
              }
              return h('Poptip', {
                props: {
                  trigger: 'hover'
                }
              }, [
                h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3)
                  + "****" + params.row.mobile.substring(7) : params.row.mobile),
                // 当前行展示的数据
                h('div', {slot: 'content'}, params.row.mobile)
              ])
            }
          },
          {
            title: '城市',
            key: 'allCity',
            // width: 100,
          },
          {
            title: '注册渠道',
            // width: 120,
            key: 'regType',
            render: (h, params) => {
              let name = params.row.regType || ''
              let type = params.row.channelType || ''
              if (type && name && type !== name) {
                return h('span', name + '（' + type + '）')
              }
              return h('span', name || type)
            }
          },
          {
            title: '推荐人',
            // width: 100,
            key: 'auName',
          },
          {
            title: '创建人',
            // width: 100,
            key: 'creatorName',
          },
          {
            title: '分配来源',
            // width: 100,
            render: (h, params) => {
              let recordsSource = params.row.recordsSource
              let recordsSourceEnum = $constant.getEnum($constant.recordsSource, recordsSource)
              return h('div', recordsSourceEnum && recordsSourceEnum.text)
            }
          },
          {
            title: '课程顾问',
            // width: 130,
            key: 'adviserName',
            render: (h, params) => {
              return h('span', params.row.adviserName || '未分配')
            }
          },
          {
            title: '分配人',
            align: 'center',
            key: 'assignerName',
            // width: 110,
          },
          {
            title: '分配时间',
            align: 'center',
            // width: 170,
            key: 'assignTime'
          },
          {
            title: '学员状态',
            // width: 110,
            render: (h, params) => {
              let status = params.row.stdStatus
              let typeEnum = $constant.getEnum($constant.stdStatus, status)
              return h('span', typeEnum && typeEnum.text)
            }
          },
        ],
      }
    },
    methods: {
      search () {
        this.selectionUser = []
        this.reload = new Date().getTime()
      },
      selectionChange (selection) {
        this.selectionUser = selection
      },
      getAdviserInfo (obj) {
        if (obj) {
          this.queryParam.adviserId = obj.adviserId
          this.queryParam.teamType = obj.teamType
          this.queryParam.adviserIds = obj.adviserIds
        }
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      goBackSalesDealRate () {
        const startDate = this.queryParam.linkStartTimeDate
        const endDate = this.queryParam.linkEndTimeDate
        let query
        if (startDate && endDate) {
          query = {
            startDate: startDate,
            endDate: endDate
          }
        } else {
          query = {
            weekStart: this.queryParam.weekStart || this.$route.query.weekStart,
            weeks: this.queryParam.weeks || this.$route.query.weeks
          }
        }
        this.$router.push({
          path: '/crm/SalesDealRate',
          query: query
        })
      },
      goBackChannelDealRate () {
        const startDate = this.queryParam.linkStartTimeDate
        const endDate = this.queryParam.linkEndTimeDate
        let query
        if (startDate && endDate) {
          query = {
            startDate: startDate,
            endDate: endDate
          }
        } else {
          query = {
            weekStart: this.queryParam.weekStart || this.$route.query.weekStart
          }
        }
        if (this.$route.query.marketCategory) {
          query.marketCategory = this.$route.query.marketCategory
        }
        this.$router.push({
          path: '/market/ChannelDealRate',
          query: query
        })
      },
      regTimeStartChange (val) {
        this.queryParam.regStartTimeDate = val
      },
      regTimeEndChange (val) {
        this.queryParam.regEndTimeDate = val
      },
      linkTimeStartChange (val) {
        this.queryParam.linkStartTimeDate = val
      },
      linkTimeEndChange (val) {
        this.queryParam.linkEndTimeDate = val
      },
    },
    created: function () {
      const query = this.$route.query
      if (query.salesDealRate == 1 || query.salesDealRate === '1') {
        this.fromSalesDealRate = true
        this.queryParam.salesDealRate = 1
        const weeks = String(query.weeks) === '8' ? 8 : 1
        this.queryParam.weeks = weeks
        if (String(query.weeks) !== String(weeks)) {
          query.weeks = weeks
        }
        if (query.weekStart) {
          this.queryParam.weekStart = query.weekStart
        }
        if (query.adviserId) {
          this.queryParam.adviserId = query.adviserId
        }
        if (query.linkStartTimeDate) {
          this.queryParam.linkStartTimeDate = query.linkStartTimeDate
        }
        if (query.linkEndTimeDate) {
          this.queryParam.linkEndTimeDate = query.linkEndTimeDate
        }
      }
      if (query.channelDealRate === 1 || query.channelDealRate === '1') {
        this.fromChannelDealRate = true
        this.queryParam.channelDealRate = 1
        if (query.weekStart) {
          this.queryParam.weekStart = query.weekStart
        }
        if (query.channelId !== undefined && query.channelId !== null && query.channelId !== '') {
          this.queryParam.channelId = query.channelId
        }
        if (query.linkStartTimeDate) {
          this.queryParam.linkStartTimeDate = query.linkStartTimeDate
        }
        if (query.linkEndTimeDate) {
          this.queryParam.linkEndTimeDate = query.linkEndTimeDate
        }
      }
    },
    mounted: function () {
      let self = this
      self.$http.get('/adminUser/listByCondition?adminGroupId=' + 4).then(function (res) {
        self.studyAdvisers = res.data
      })
      this.cmd = 1
      this.title = this.assignTitle
      this.search()
    },
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// DistributionList.vue?32913ab2